import React from 'react';
import { Navigator } from '@/presentation/routing/Navigator';
import { qaAttr } from '@/presentation/utils/qaAttr';

export const renderMentionText = (text: string, accentColor: string): React.ReactNode => {
  const parts = text.split(/(\s+)/);
  return parts.map((p, i) => {
    if (p.startsWith('@')) {
      const mention = p.substring(1);
      return (
        <button
          key={i}
          {...qaAttr({ id: `mention-${mention}` })}
          onClick={() => Navigator.navigateToUserDetailsByMention(mention)}
          style={{
            color: accentColor,
            background: 'none',
            border: 'none',
            padding: 0,
            font: 'inherit',
            cursor: 'pointer',
          }}
        >
          {p}
        </button>
      );
    }
    return <React.Fragment key={i}>{p}</React.Fragment>;
  });
};
